import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { useState } from 'react'
import { AlertTriangle } from 'react-feather'

import { HeaderRow, LoadedRow, LoadingRow } from './TableRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow setShowLiqPrice="" showLiqPirce={false} />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function PositionTable({ positions, closePosition, editPosition }: any) {
  const loadingVotes = true
  const positionList = positions
  const [showLiqPirce, setShowLiqPrice] = useState(false)
  /* loading and error state */
  if (loadingVotes && !positionList) {
    return <LoadingTokenTable rowCount={4} />
  } else if (!positionList) {
    return (
      <NoTokensState
        thRow={<HeaderRow setShowLiqPrice={setShowLiqPrice} showLiqPirce={showLiqPirce} />}
        message={
          <>
            <AlertTriangle size={4} />
            <Trans>An error occurred loading positionList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (positionList?.length === 0) {
    return (
      <NoTokensState
        thRow={<HeaderRow setShowLiqPrice={setShowLiqPrice} showLiqPirce={showLiqPirce} />}
        message={<Trans>No positionList found</Trans>}
      />
    )
  } else {
    return (
      <>
        <HeaderRow setShowLiqPrice={setShowLiqPrice} showLiqPirce={showLiqPirce} />
        <TableDataContainer>
          {positionList?.map((position: any, index: any) => (
            <LoadedRow
              key={index}
              positionListIndex={index}
              positionListLength={positionList.length}
              position={position}
              closePosition={closePosition}
              editPosition={editPosition}
              showLiqPirce={showLiqPirce}
            />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
